import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ y, opacity: 0, scale: 0.98 }}
    whileInView={{ y: 0, opacity: 1, scale: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-xs tracking-[0.35em] uppercase text-champagne/80 mb-6">
    {children}
  </p>
);

export const SectionHeading = ({ eyebrow, title, copy, align = "left" }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Eyebrow>{eyebrow}</Eyebrow>
    <h2 className="font-display font-light tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-pearl">
      {title}
    </h2>
    {copy && <p className="mt-6 text-base md:text-lg text-zinc-500 font-light leading-relaxed">{copy}</p>}
  </Reveal>
);

export const SectionCta = ({ id, label = "Book My Revenue Leak Audit" }) => (
  <Reveal className="mt-14 flex justify-center">
    <a
      href="#book"
      data-testid={`${id}-cta`}
      className="btn-shine inline-flex items-center gap-3 rounded-full bg-champagne px-7 py-3.5 text-sm font-medium tracking-wide text-white hover:bg-champagne-soft transition-colors duration-300 group"
    >
      {label}
      <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1.5" />
    </a>
  </Reveal>
);
